import { savedJQuery } from '../components/jquery'

/**
 * @param {HTMLElement} element 
 * @param {string} hint 
 * @param {string} side
 */
export function addHint (element, hint, side) {
  element.setAttribute('data-toggle', 'tooltip')
  element.setAttribute('data-placement', side)
  element.setAttribute('title', hint)
  element.setAttribute('tabindex', '0')
  element.setAttribute('data-html', 'true')
  element.setAttribute('data-original-title', hint)

  // eslint-disable-next-line no-undef
  savedJQuery(function () {
    // eslint-disable-next-line no-undef
    savedJQuery(element).tooltip()
  })
}

/**
 * @param {HTMLElement} element 
 * @param {string} newHintText 
 */
export function changeHint (element, newHintText) {
  element.setAttribute('data-original-title', newHintText)
}

/**
 * @param {HTMLElement} element 
 */
export function removeHint (element) {
  element.setAttribute('data-original-title', '')
}

export const contentHint = 'Imate problem u sadržaju'

export const tooLongWorkDescriptionHint = 'Sadržaj predugačak'

export const tooLongRemarksHint = 'Sadržaj predugačak'

export const hourHint = 'Vreme mora biti broj između 0 i 23'

export const emptyRemarksHint = 'Ne možete potpisati dok ne popunite primedbe.'

export const emptyWorkDescriptionHint = 'Ne možete potpisati dok ne popunite opis rada.'

export const noShiftsFilledHint = 'Ne možete potpisati dok ne popunite barem jednu smenu.'

export const noTemperaturesFilledHint =
  'Ne možete potpisati dok ne popunite barem jednu temperaturu.'

export const emptyWeatherHint = 'Ne možete potpisati dok ne popunite vreme.'

export const emptyMechanizationHint =
  'Ne možete potpisati dok ne popunite mehanizaciju.'

export const partlyFilledShiftHint =
  'Za svaku započetu smenu moraju biti popunjena polja vremena i broj radnika'

export const partlyFilledTemperatureHint =
  'Za svako započeto polje temperature moraju biti popunjena polja vreme i temperatura'

export const temperatureHint =
  'Temperatura treba da bude u formatu 48.9 i u opsegu [-100; 100]'

export const weatherHint = 'Vreme mora biti do 40 karaktera'

export const nWorkersHint =
  'Broj radnika mora biti ceo pozitivan broj manji od 1000'

export const mechanizationHint =
  'Mehanizacija ne može biti duža od 450 karaktera'